import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { eventInfo } from "../../services/EventApi";
import { toast } from "react-toastify";

const EquipmentDeleteModal = ({
  isOpen,
  toggle,
  data,
  fetchEventList,
  activeColors,
}) => {
  console.log(data);

  const [isDeleting, setIsDeleting] = useState(false);

  const deleteEvent = async () => {
    setIsDeleting(true);
    try {
      const response = await eventInfo({
        request_type: "remove",
        plant_id: "MG_PLANT_1",
        event_id: data.event_id,
      });
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDelete = async () => {
    await deleteEvent();
    await fetchEventList();
    toggle();
  };

  return (
    <Modal centered isOpen={isOpen} size="lg" className="equipmentModal">
      <ModalHeader>イベントを削除する</ModalHeader>

      <ModalBody>
        {/* Event Info */}
        <div className="event-info">
          <div className="info-row1">
            <span className="labeldelete">日時：</span>
            <span
              className="highlight"
              style={{ backgroundColor: activeColors }}
            >
              {data.start_time} ～ {data.end_time}
            </span>
          </div>

          <div className="info-row1">
            <span className="labeldelete">名：</span>
            <span>{data.title}</span>
          </div>

          <div className="info-row1">
            <span className="labeldelete">詳細：</span>
            <span style={{ whiteSpace: "pre-line" }}>{data.description}</span>
          </div>
        </div>

        <hr className="divider" />

        {/* Confirmation text */}
        <div className="confirm-text">
          本当にこのイベントを削除してもよろしいですか?
        </div>
      </ModalBody>

      <ModalFooter className="footer footerdelete ">
        <Button
          className="btn cancel btndelete"
          onClick={toggle}
          disabled={isDeleting}
        >
          キャンセル
        </Button>
        <Button
          className="btn add btndelete"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {isDeleting ? <Spinner size="sm" /> : "削除"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EquipmentDeleteModal;
